<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.name"
          :label="$t('global.name')"
          type="text"
        />
      </v-col>

      <v-row cols="12"></v-row>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-model="item.designFile"
          :items="designFileSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          :label="$t('prodfile.designfile')"
          item-text="name"
          item-value="@id"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <v-combobox

          v-model="item.machine"
          :items="machineSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          :label="$t('machine.machine')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-model="item.tool"
          :items="toolrefSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          :label="$t('tool.tool')"
          item-text="name"
          item-value="@id"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-model="item.surface"
          :items="surfaceSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          :label="$t('printingsurface.printingsurface')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-model="item.material"
          :items="materialSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          :label="$t('material.material')"
          item-text="name"
          item-value="@id"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-model="item.nozzle"
          :items="nozzleSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          :label="$t('nozzle.nozzle')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
            v-model="item.createdBy"
            :items="createdBySelectItems"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('global.createdby')"
            item-text="login"
            item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <h3>{{ $t('global.createdat') }}</h3>
    </v-row>
    <v-row>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.created_after"
          :label="$t('global.datestart')"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.created_before"
          :label="$t('global.dateend')"
        />
      </v-col>

    </v-row>
    <v-row>
      <h3>{{ $t('global.updatedat') }}</h3>
    </v-row>
    <v-row>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.updated_after"
          :label="$t('global.datestart')"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.updated_before"
          :label="$t('global.dateend')"
        />
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import InputDate from '../InputDate';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
export default {
  name: 'ProdFileFilter',
  components: {
    InputDate,
  },
  props: {
    values: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  mounted() {
      this.machineGetSelectItems();
      this.toolrefGetSelectItems();
      this.surfaceGetSelectItems();
      this.materialGetSelectItems();
      this.nozzleGetSelectItems();
      this.designFileGetSelectItems();
      this.createdByGetSelectItems();
  },
  computed: {
    // eslint-disable-next-line
    ...mapFields('machine', {
      machineSelectItems: 'selectItems',
    }),
    ...mapFields('toolref', {
      toolrefSelectItems: 'selectItems',
    }),
    ...mapFields('printingsurface', {
      surfaceSelectItems: 'selectItems',
    }),
    ...mapFields('user', {
      createdBySelectItems: 'selectItems',
    }),
    ...mapFields('material', {
      materialSelectItems: 'selectItems',
    }),
    ...mapFields('nozzle', {
      nozzleSelectItems: 'selectItems',
    }),
    ...mapFields('designfile', {
      designFileSelectItems: 'selectItems',
    }),
    item() {
      return this.initialValues || this.values;
    }
  },
  methods: {
    ...mapActions({
      machineGetSelectItems: 'machine/fetchSelectItems',
      toolrefGetSelectItems: 'toolref/fetchSelectItems',
      surfaceGetSelectItems: 'printingsurface/fetchSelectItems',
      materialGetSelectItems: 'material/fetchSelectItems',
      nozzleGetSelectItems: 'nozzle/fetchSelectItems',
      designFileGetSelectItems: 'designfile/fetchSelectItems',
      createdByGetSelectItems: 'user/fetchSelectItems'
    })
  }
};
</script>
